import type { ModalHandle, PickerItemValidCheck } from "@9amhealth/shared";
import { Modal } from "@9amhealth/shared";
import { getLocalTimeZone, now, ZonedDateTime } from "@internationalized/date";
import React, { FC, useRef } from "react";
import { TimePickerSheet } from "../TimePickerSheet/TimePickerSheet";

const DateTimePicker: FC<{
  show: boolean;
  onFinish?: (dateTime: ZonedDateTime) => void;
  onChange?: (dateTime: ZonedDateTime) => void;
  initialDate?: ZonedDateTime;
  title: string;
  granularity: "day" | "minute" | "ymd";
  daysBack?: number;
  daysForward?: number;
  yearsBack?: number;
  yearsForward?: number;
  validateDate?: PickerItemValidCheck;
}> = (props) => {
  const {
    show,
    onFinish,
    onChange,
    initialDate = now(getLocalTimeZone()),
    title,
    granularity,
    daysBack,
    daysForward,
    yearsBack,
    yearsForward,
    validateDate
  } = props;
  const selected = useRef<ZonedDateTime>(initialDate);
  const modalRef = useRef<ModalHandle>(null);

  const handleFinish = () => {
    onFinish?.(selected.current);
  };

  const handleSelectChange = (dateTime: ZonedDateTime) => {
    selected.current = dateTime;
    onChange?.(dateTime);
  };

  if (!show) {
    return null;
  }

  return (
    <Modal
      ref={modalRef}
      variant="sheet"
      isOpen={show}
      onDidDismiss={handleFinish}
      ariaLabel={title}
      disableDrag
    >
      <TimePickerSheet
        onRequestClose={() => modalRef.current?.dismiss()}
        onChange={handleSelectChange}
        title={title}
        granularity={granularity}
        initialDate={initialDate}
        daysBack={daysBack}
        daysForward={daysForward}
        yearsBack={yearsBack}
        yearsForward={yearsForward}
        validateDate={validateDate}
      />
    </Modal>
  );
};

export default DateTimePicker;
